import { render, staticRenderFns } from "./StepLogistics.vue?vue&type=template&id=2a53146e&scoped=true"
import script from "./StepLogistics.vue?vue&type=script&lang=js"
export * from "./StepLogistics.vue?vue&type=script&lang=js"
import style0 from "./StepLogistics.vue?vue&type=style&index=0&id=2a53146e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a53146e",
  null
  
)

export default component.exports